/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

type UtilRequiredKeys<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;

export type UiFieldIncludesOperator = "includes" | "notIncludes";

export type UiFieldConditionalResult =
  | "required"
  | "hidden"
  | "readOnly"
  | "optional"
  | "disallow";

export type UiFieldConditionalRangeOperator = "between" | "notBetween";

export type UiFieldConditionalBoolOperator = "equals" | "notEquals";

export type UIGroupConditionalResult = "hidden";

export type UIFieldNumericControl = "input" | "select";

export type TickJobResponseType =
  | "info"
  | "success"
  | "error"
  | "warning"
  | "tech";

export type SupplyPlenumCollarType = "rectangle" | "circle";

export type RelationshipEntity =
  | "room"
  | "zone"
  | "appliance"
  | "hood"
  | "vav"
  | "supply"
  | "exhaust"
  | "group"
  | "diffuser";

export type MeasurementType =
  | "unspecified"
  | "length"
  | "mass"
  | "volume"
  | "temperature"
  | "power"
  | "energy"
  | "area"
  | "volumetricFlowRate"
  | "pressure"
  | "other";

export type HoodExhaustCollarPropertiesType = "rectangle" | "circle";

export type HoodAirchefValuesShape = "rectangle" | "circle" | "oval";

export type EquationSchemaType = "on-demand" | "automatic";

export type EquationOutputValueOperation =
  | "replace"
  | "append"
  | "merge"
  | "removeKey"
  | "removeValue"
  | "insert"
  | "removeKeys"
  | "removeValues";

export type EquationOutputOperation =
  | "undefined"
  | "replace"
  | "append"
  | "merge"
  | "removeKey"
  | "removeValue"
  | "insert"
  | "removeKeys"
  | "removeValues";

export type DiffuserCollarPropertiesType = "rectangle" | "circle";

export type UiFieldConditional = BaseUiFieldConditional &
  (
    | BaseUiFieldConditionalTypeMapping<"int", UiFieldConditionalInt>
    | BaseUiFieldConditionalTypeMapping<"boolean", UiFieldConditionalBoolean>
    | BaseUiFieldConditionalTypeMapping<"string", UiFieldConditionalString>
    | BaseUiFieldConditionalTypeMapping<
        "measurement",
        UiFieldConditionalMeasurement
      >
    | BaseUiFieldConditionalTypeMapping<"enum", UiFieldConditionalEnum>
    | BaseUiFieldConditionalTypeMapping<
        "stringIncludes",
        UiFieldConditionalStringIncludes
      >
    | BaseUiFieldConditionalTypeMapping<
        "intIncludes",
        UiFieldConditionalIntegerIncludes
      >
    | BaseUiFieldConditionalTypeMapping<
        "measurementIncludes",
        UiFieldConditionalMeasurementIncludes
      >
    | BaseUiFieldConditionalTypeMapping<
        "moduleIncludes",
        UiFieldConditionalModuleIncludes
      >
    | BaseUiFieldConditionalTypeMapping<"intRange", UiFieldConditionalIntRange>
    | BaseUiFieldConditionalTypeMapping<
        "measurementRange",
        UiFieldConditionalMeasurementRange
      >
  );

export type UIGroupConditional = BaseUiGroupConditional &
  (
    | BaseUiGroupConditionalTypeMapping<"int", UiGroupConditionalInt>
    | BaseUiGroupConditionalTypeMapping<"boolean", UiGroupConditionalBoolean>
    | BaseUiGroupConditionalTypeMapping<"string", UiGroupConditionalString>
    | BaseUiGroupConditionalTypeMapping<
        "measurement",
        UiGroupConditionalMeasurement
      >
    | BaseUiGroupConditionalTypeMapping<"enum", UiGroupConditionalEnum>
    | BaseUiGroupConditionalTypeMapping<
        "stringIncludes",
        UiGroupConditionalStringIncludes
      >
    | BaseUiGroupConditionalTypeMapping<
        "intIncludes",
        UiGroupConditionalIntegerIncludes
      >
    | BaseUiGroupConditionalTypeMapping<
        "measurementIncludes",
        UiGroupConditionalMeasurementIncludes
      >
    | BaseUiGroupConditionalTypeMapping<
        "moduleIncludes",
        UiGroupConditionalModuleIncludes
      >
    | BaseUiGroupConditionalTypeMapping<"intRange", UiGroupConditionalIntRange>
    | BaseUiGroupConditionalTypeMapping<
        "measurementRange",
        UiGroupConditionalMeasurementRange
      >
  );

export type UIBasePart = BaseUiBasePart &
  (
    | BaseUiBasePartTypeMapping<"text", UIFieldText>
    | BaseUiBasePartTypeMapping<"date", UIFieldDate>
    | BaseUiBasePartTypeMapping<"time", UIFieldTime>
    | BaseUiBasePartTypeMapping<"toggle", UIFieldToggle>
    | BaseUiBasePartTypeMapping<"number", UIFieldNumber>
    | BaseUiBasePartTypeMapping<"radioButtons", UIFieldRadioButtons>
    | BaseUiBasePartTypeMapping<"radioButtonsEnum", UIFieldRadioButtonsEnum>
    | BaseUiBasePartTypeMapping<"select", UIFieldSelect>
    | BaseUiBasePartTypeMapping<"selectNumber", UIFieldSelectNumber>
    | BaseUiBasePartTypeMapping<"selectEnum", UIFieldSelectEnum>
    | BaseUiBasePartTypeMapping<"measurement", UIFieldMeasurement>
    | BaseUiBasePartTypeMapping<"textarea", UIFieldTextArea>
    | BaseUiBasePartTypeMapping<"relationship", UIFIeldRelationship>
    | BaseUiBasePartTypeMapping<"module", UIFieldModule>
    | BaseUiBasePartTypeMapping<"chart", UIFieldChart>
    | BaseUiBasePartTypeMapping<"bookmark", UIFieldBookmark>
    | BaseUiBasePartTypeMapping<"twoColHeader", UIElementTwoColumnHeader>
    | BaseUiBasePartTypeMapping<
        "twoColMeasurement",
        UIElementTwoColumnMeasurement
      >
  );

export type DataViewColumn = BaseDataViewColumn &
  (
    | BaseDataViewColumnTypeMapping<"number", DataViewColumnNumber>
    | BaseDataViewColumnTypeMapping<"string", DataViewColumnString>
    | BaseDataViewColumnTypeMapping<"measurement", DataViewColumnMeasurement>
    | BaseDataViewColumnTypeMapping<"enum", DataViewColumnEnum>
    | BaseDataViewColumnTypeMapping<"boolean", DataViewColumnBoolean>
    | BaseDataViewColumnTypeMapping<"module", DataViewColumnModule>
    | BaseDataViewColumnTypeMapping<"translated", DataViewColumnTranslated>
  );


// Branded ID types for type safety
export type ApplianceId = string & { readonly __type: 'appliance' };
export type CeilingExhaustPlenumId = string & { readonly __type: 'ceiling-exhaust-plenum' };
export type CeilingPlenumCollarId = string & { readonly __type: 'ceiling-plenum-collar' };
export type CeilingPlenumFilterId = string & { readonly __type: 'ceiling-plenum-filter' };
export type CeilingSupplyPlenumId = string & { readonly __type: 'ceiling-supply-plenum' };
export type DiffuserId = string & { readonly __type: 'diffuser' };
export type ExhaustId = string & { readonly __type: 'exhaust' };
export type GroupId = string & { readonly __type: 'group' };
export type HoodId = string & { readonly __type: 'hood' };
export type ModuleId = string & { readonly __type: 'module' };
export type ProjectId = string & { readonly __type: 'project' };
export type RoomId = string & { readonly __type: 'room' };
export type RowId = string & { readonly __type: 'row' };
export type SupplyId = string & { readonly __type: 'supply' };
export type VAVId = string & { readonly __type: 'vav' };
export type VentilatedCeilingId = string & { readonly __type: 'ceiling' };
export type ZoneId = string & { readonly __type: 'zone' };

export interface Appliance {
  schemaPath: string;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: ApplianceId;
  /** @minLength 1 */
  type: "appliance";
  relations: ApplianceRelations;
  airchefValues: ApplianceAirchefValues;
  haltonValues: HaltonValues;
}

export interface ApplianceAirchefValues {
  name: string;
  transform: Transform;
  datesAndAudit: DatesAndAudit;
  itemNumber?: null | string;
  itemNumberOverride?: null | string;
  positionOffset?: PositionPartial;
  offsetTransform?: OffsetTransformProperties;
  "3dModel"?: null | string;
  imageThumbnail?: null | string;
  image?: null | string;
  comment?: null | string;
  isDraft?: null | boolean;
  region: Enum;
  hoodRequiredFlag: boolean;
  energySourceType: Enum;
  [key: string]: any;
}

export interface AppliancePositioner {
  applianceId: ApplianceId;
  offset: PositionPlane;
}

export interface ApplianceRelations {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  groupId?: null | GroupId;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  rowNum?: null | number;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  rowId?: null | RowId;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  roomId?: null | RoomId;
  hoodIds?: null | HoodId[];
  hoodIdsAbove?: null | string[];
}

export interface AppliancesResponse {
  appliances: Appliance[];
  types: string[];
}

export interface CeilingAirchefValues {
  name: string;
  /** @format int32 */
  id: number;
  description: LocalisedText;
  datesAndAudit: DatesAndAudit;
  comment?: null | string;
  image?: null | string;
  imageThumbnail?: null | string;
  "3dModel"?: null | string;
  transform: Transform;
  supplyPlenums: CeilingSupplyPlenum[];
  exhaustPlenums: CeilingExhaustPlenum[];
  /** @format double */
  maxSupplyPlenums?: null | number;
  /** @format double */
  maxExhaustPlenums?: null | number;
  configurablePlenums?: null | boolean;
  region?: Enum;
  [key: string]: any;
}

export interface CeilingExhaustPlenum {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: CeilingExhaustPlenumId;
  schemaPath: string;
  /** @minLength 1 */
  type: "ceiling-exhaust-plenum";
  airchefValues: CeilingExhaustPlenumAirchefValues;
  haltonValues: HaltonValues;
}

export interface CeilingExhaustPlenumAirchefValues {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  modelId: string;
  displayName: LocalisedText;
  filters: CeilingPlenumFilter[];
  collars: CeilingPlenumCollar[];
  /** @format double */
  maxCollars?: null | number;
  /** @format double */
  maxFilters?: null | number;
  [key: string]: any;
}

export interface CeilingPlenumCollar {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: CeilingPlenumCollarId;
  schemaPath: string;
  /** @minLength 1 */
  type: "ceiling-plenum-collar";
  airchefValues: CeilingPlenumCollarAirchefValues;
  haltonValues: HaltonValues;
}

export interface CeilingPlenumCollarAirchefValues {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  modelId: string;
  displayName: LocalisedText;
  [key: string]: any;
}

export interface CeilingPlenumFilter {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: CeilingPlenumFilterId;
  schemaPath: string;
  /** @minLength 1 */
  type: "ceiling-plenum-filter";
  airchefValues: CeilingPlenumFilterAirchefValues;
  haltonValues: HaltonValues;
}

export interface CeilingPlenumFilterAirchefValues {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  modelId: string;
  displayName: LocalisedText;
  [key: string]: any;
}

export interface CeilingRelations {
  groupIds?: null | GroupId[];
  roomId?: null | RoomId;
}

export interface CeilingSupplyPlenum {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: CeilingSupplyPlenumId;
  schemaPath: string;
  /** @minLength 1 */
  type: "ceiling-supply-plenum";
  airchefValues: CeilingSupplyPlenumAirchefValues;
  haltonValues: HaltonValues;
}

export interface CeilingSupplyPlenumAirchefValues {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  modelId: string;
  displayName: LocalisedText;
  collars: CeilingPlenumCollar[];
  /** @format double */
  maxCollars?: null | number;
  [key: string]: any;
}

export interface Comment {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: string;
  content: string;
  transform: Transform;
  datesAndAudit: DatesAndAudit;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  roomId: RoomId;
  pointTo?: Position;
}

export interface Corner {
  position: Position;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: string;
  height: LengthValue;
  [key: string]: any;
}

export interface DataView {
  /** @format uuid */
  id?: string;
  /** @minLength 1 */
  schemaPath: string;
  /** @minLength 1 */
  haltonType: string;
  itemType?: string;
  /** @format date-time */
  createdAt?: null | string;
  createdBy?: null | string;
  /** @format date-time */
  modifiedAt?: null | string;
  modifiedBy?: null | string;
  configuration: DataViewItemConfiguration;
}

export type DataViewColumnBoolean = BaseDataViewColumn & object;

export type DataViewColumnEnum = BaseDataViewColumn & object;

export interface DataViewColumnFractionDigits {
  /** @format int32 */
  us?: null | number;
  /** @format int32 */
  si?: null | number;
}

export type DataViewColumnMeasurement = BaseDataViewColumn & {
  unit: DataViewColumnMeasurementPreferredUnits;
  fractionDigits?: DataViewColumnFractionDigits;
};

export interface DataViewColumnMeasurementPreferredUnits {
  us?: null | string;
  si?: null | string;
}

export type DataViewColumnModule = BaseDataViewColumn & object;

export type DataViewColumnNumber = BaseDataViewColumn & {
  /** @format int32 */
  fractionDigits?: null | number;
};

export type DataViewColumnString = BaseDataViewColumn & object;

export type DataViewColumnTranslated = BaseDataViewColumn & object;

export interface DataViewItemConfiguration {
  /** @minLength 1 */
  itemType: string;
  columns: (
    | DataViewColumnNumber
    | DataViewColumnString
    | DataViewColumnMeasurement
    | DataViewColumnEnum
    | DataViewColumnBoolean
    | DataViewColumnModule
    | DataViewColumnTranslated
  )[];
  defaultColumns: string[];
}

export interface DataWarning {
  message: string;
  productIds: string[];
  /** @format double */
  timestamp: number;
  [key: string]: any;
}

export interface DatesAndAudit {
  author?: null | string;
  /** @format date-time */
  createdAt: string;
  modifiedBy?: null | string;
  /** @format date-time */
  modifiedAt?: null | string;
  deletedBy?: null | string;
  /** @format date-time */
  deletedAt?: null | string;
  /** @format date-time */
  modifiedAtBySystem?: null | string;
}

export interface Diffuser {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: DiffuserId;
  schemaPath: string;
  /** @minLength 1 */
  type: "diffuser";
  airchefValues: DiffuserAirchefValues;
  haltonValues: HaltonValues;
  relations: DiffuserRelations;
}

export interface DiffuserAirchefValues {
  name: string;
  /** @format int32 */
  id: number;
  description: LocalisedText;
  datesAndAudit: DatesAndAudit;
  comment?: null | string;
  image?: null | string;
  imageThumbnail?: null | string;
  transform: Transform;
  collar?: DiffuserCollarProperties;
  region?: Enum;
  [key: string]: any;
}

export interface DiffuserCollarProperties {
  /**
   * @format int32
   * @min 1
   * @max 3
   */
  count: number;
  type: DiffuserCollarPropertiesType;
  length: LengthValue;
  width?: LengthValue;
  /**
   * @maxItems 3
   * @minItems 1
   */
  backDistance: LengthValue[];
  /**
   * @maxItems 3
   * @minItems 1
   */
  centerDistance: LengthValue[];
}

export interface DiffuserRelations {
  supplyId?: null | SupplyId;
  vavId?: null | VAVId;
  roomId?: null | RoomId;
  zoneId?: null | ZoneId;
}

export interface EnergyValue {
  /** @format double */
  value: number;
  type: "energy";
  unit: string;
  unitSystem?: null | string;
}

export interface Enum {
  value: EnumItem;
  /** @minItems 1 */
  enum: EnumItem[];
}

export interface EnumItem {
  label: LocalisedText;
  description?: LocalisedText;
  value: string;
  [key: string]: any;
}

export interface Equation {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  version: string;
  id?: null | string;
  type?: null | string;
  sync?: null | EquationModelSync[];
  /** @format double */
  runCooldown?: null | number;
  jsonPathTriggers?: null | string[];
  inputs: Record<string, string>;
  outputs: Record<string, EquationOutput>;
}

export interface EquationModelSync {
  /** @minLength 1 */
  key: string;
  jsonPathSpecifiers?: null | string[];
}

export interface EquationOutput {
  operation: EquationOutputOperation;
  /** @minLength 1 */
  jsonPath: string;
}

export interface EquationOutputValue {
  jsonPath: string;
  operation: EquationOutputValueOperation;
  [key: string]: any;
}

export interface EquationRunMetadata {
  /** @format date-time */
  succeededAt?: null | string;
  [key: string]: any;
}

export interface EquationRunRequest {
  name: string;
  version: string;
  inputs: Record<string, null>;
}

export interface EquationSchema {
  name: string;
  /** @pattern ^\d+.* */
  version: string;
  id?: null | string;
  type?: EquationSchemaType;
  sync?: null | EquationSync[];
  inputs: Record<string, string>;
  outputs: Record<string, EquationOutputValue>;
  runMetadata?: null | Record<string, EquationRunMetadata>;
  /** @format double */
  runCooldown?: null | number;
  jsonPathTriggers?: null | string[];
}

export interface EquationSync {
  key: string;
  jsonPathSpecifiers?: null | string[];
  [key: string]: any;
}

export interface Equations {
  schemaPath: string;
  haltonType: string;
  /** @format date-time */
  createdAt?: null | string;
  createdBy?: null | string;
  /** @format date-time */
  modifiedAt?: null | string;
  modifiedBy?: null | string;
  equations: EquationSchema[];
  [key: string]: any;
}

export interface EquationsDatabaseSchema {
  /** @minLength 1 */
  schemaPath: string;
  /** @minLength 1 */
  haltonType: string;
  /** @format date-time */
  createdAt?: null | string;
  createdBy?: null | string;
  /** @format date-time */
  modifiedAt?: null | string;
  modifiedBy?: null | string;
  equations: null | Equation[];
}

export interface Exhaust {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: ExhaustId;
  /** @minLength 1 */
  type: "exhaust";
  schemaPath: string;
  airchefValues: ExhaustAirchefValues;
  haltonValues: HaltonValues;
  relations: ExhaustRelations;
}

export interface ExhaustAirchefValues {
  name: string;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  modelId?: null | string;
  description?: null | string;
  datesAndAudit: DatesAndAudit;
  comment?: null | string;
  image?: null | string;
  imageThumbnail?: null | string;
  [key: string]: any;
}

export interface ExhaustRelations {
  hoodIds: HoodId[];
  zoneIds: ZoneId[];
}

export interface FireCabinet {
  offsetTransform: OffsetTransformProperties;
  "3dModel"?: null | string;
  [key: string]: any;
}

export interface GeneratePdfRequest {
  project: Project;
  images: Record<string, string>;
  roomIds: RoomId[];
  roomLayout: boolean;
  hoodList: boolean;
  cookingLineSpecifications: boolean;
  hoodSpecifications: boolean;
  supplyDeviceList: boolean;
  supplyDeviceGroupSpecifications: boolean;
  fireSuppressionSpecifications: boolean;
  airConditioningCalculations: boolean;
  systems: boolean;
  paybackTimeReport: boolean;
  templateId?: null | string;
}

export interface GeneratePdfResponse {
  base64Content?: null | string;
}

export interface Group {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: GroupId;
  schemaPath: string;
  /** @minLength 1 */
  type: "group";
  relations: GroupRelations;
  airchefValues: GroupAirchefValues;
  haltonValues: HaltonValues;
  /**
   * @maxItems 2
   * @minItems 1
   */
  rows: Row[];
}

export interface GroupAirchefValues {
  transform: Transform;
  has2Row?: null | boolean;
  itemNumber?: null | string;
  comment?: null | string;
  /** @maxItems 2 */
  fireCabinets: FireCabinet[];
  kds: KDS;
  hasVirtualWall?: null | boolean;
  [key: string]: any;
}

export interface GroupRelations {
  applianceIds: ApplianceId[];
  hoodIds: HoodId[];
  roomId: RoomId;
}

export interface HVACSettings {
  schemaPath: string;
  type: "hvac";
  roomCoolingTemperature?: TemperatureValue;
  roomHeatingTemperature?: TemperatureValue;
  roomCoolingRelativeHumidity?: OtherValue;
  roomHeatingRelativeHumidity?: OtherValue;
  outdoorHeatingTemperature?: TemperatureValue;
  outdoorHeatingRelativeHumidity?: OtherValue;
  transferHeatingTemperature?: TemperatureValue;
  transferHeatingRelativeHumidity?: OtherValue;
  transferAirflowType?: Enum;
  transferAirflowPct?: OtherValue;
  transferAirflowVolume?: VolumetricFlowRateValue;
  generalSupplyAir?: Enum;
  hoodSupplyAir?: Enum;
  averageSupplyCoolingTemperature?: TemperatureValue;
  averageSupplyHeatingTemperature?: TemperatureValue;
  averageSupplyCoolingRelativeHumidity?: OtherValue;
  hoodExhaustTemperature?: TemperatureValue;
  hoodCapturedTemperature?: TemperatureValue;
  recirculationGeneralVentilation?: OtherValue;
}

export interface HaltonValues {
  /** @minLength 1 */
  type: string;
  [key: string]: any;
}

export interface HeatLoad {
  schemaPath: string;
  type: "heatload";
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  occupantsStandingLightWorkPeople?: null | number;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  occupantsHeavyWorkPeople?: null | number;
  solarHeatVertical?: PowerValue;
  solarHeatHorizontal?: PowerValue;
  incandescentOccupiedZone?: PowerValue;
  incandescentNearCeiling?: PowerValue;
  fluorescentOccupiedZone?: PowerValue;
  fluorescentNearCeiling?: PowerValue;
  constructionHeatGainCeiling?: PowerValue;
  constructionHeatGainWalls?: PowerValue;
}

export interface Hood {
  schemaPath: string;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: HoodId;
  /** @minLength 1 */
  type: "hood";
  relations: HoodRelations;
  airchefValues: HoodAirchefValues;
  haltonValues: HaltonValues;
}

export interface HoodAirchefValues {
  name: string;
  transform: Transform;
  datesAndAudit: DatesAndAudit;
  positionOffset?: PositionPartial;
  offsetTransform?: OffsetTransformProperties;
  "3dModel"?: null | string;
  imageThumbnail?: null | string;
  image?: null | string;
  itemNumber?: null | string;
  itemNumberOverride?: null | string;
  comment?: null | string;
  collar: HoodExhaustCollarProperties;
  hasSupplyPlenum: boolean;
  /** @maxItems 2 */
  supplyPlenum?: null | SupplyPlenum[];
  isDraft?: null | boolean;
  region?: Enum;
  canSplit?: null | boolean;
  shape?: HoodAirchefValuesShape;
  [key: string]: any;
}

export interface HoodExhaustCollarProperties {
  /**
   * @format int32
   * @min 1
   * @max 3
   */
  count: number;
  type: HoodExhaustCollarPropertiesType;
  length: LengthValue;
  width?: LengthValue;
  /**
   * @maxItems 3
   * @minItems 1
   */
  backDistance: LengthValue[];
  /**
   * @maxItems 3
   * @minItems 1
   */
  centerDistance: LengthValue[];
}

export interface HoodRelations {
  groupId?: null | GroupId;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  rowNum?: null | number;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  rowId?: null | RowId;
  roomId?: null | RoomId;
  exhaustId?: null | ExhaustId;
  zoneId?: null | ZoneId;
}

export interface KDS {
  hasKds: boolean;
  width: LengthValue;
  columnLength: LengthValue;
  columnHeight?: LengthValue;
  centerHeight?: LengthValue;
  centerPositionZ?: LengthValue;
  [key: string]: any;
}

export interface LengthValue {
  /** @format double */
  value: number;
  type: "length";
  unit: string;
  unitSystem?: null | string;
}

export interface LocalisedText {
  en?: null | string;
  [key: string]: any;
}

export interface MassValue {
  /** @format double */
  value: number;
  type: "mass";
  unit: string;
  unitSystem?: null | string;
}

export interface Module {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: ModuleId;
  /** @minLength 1 */
  type: "module";
  schemaPath: string;
  airchefValues: ModuleAirchefValues;
  haltonValues: HaltonValues;
}

export interface ModuleAirchefValues {
  name: string;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  modelId?: null | string;
  description?: LocalisedText;
  datesAndAudit: DatesAndAudit;
  comment?: null | string;
  image?: null | string;
  imageThumbnail?: null | string;
  [key: string]: any;
}

export interface ModuleOptions {
  modulesAvailable: string[];
  modulesSelected: ModuleSelection[];
  [key: string]: any;
}

export interface ModuleSelection {
  module: Module;
  locked?: null | boolean;
  [key: string]: any;
}

export interface OffsetTransformProperties {
  position: Position;
  size: Size;
}

export interface OtherValue {
  /** @format double */
  value: number;
  type: "other";
  unit: string;
  unitSystem?: null | string;
}

export interface Payback {
  schemaPath: string;
  type: "payback";
  inputs?: PaybackInputs;
  outputs?: PaybackOutputs;
}

export interface PaybackInputs {
  currency?: Enum;
  stationsDataPath?: null | string;
  countryCode?: null | string;
  weatherStation?: null | string;
  weatherDataFilePath?: null | string;
  elevation?: LengthValue;
  outdoorAirCoolingDesignDryBulbTemperature?: TemperatureValue;
  outdoorAirCoolingDesignWetBulbTemperature?: TemperatureValue;
  outdoorAirHeatingDesignDryBulbTemperature?: TemperatureValue;
  gridCarbonDioxideEmissionFactor?: OtherValue;
  /**
   * @format double
   * @min 0
   * @max 7
   */
  workDaysPerWeek?: null | number;
  /** @format double */
  competitorAirflowIncreaseFactor?: null | number;
  /** @format double */
  demandControlledVentilationAirflowReductionFactor?: null | number;
  heatingEnableTemperature?: TemperatureValue;
  coolingEnableTemperature?: TemperatureValue;
  /**
   * @format double
   * @min 0
   * @max 24
   */
  workdayStartHour?: null | number;
  /**
   * @format double
   * @min 0
   * @max 24
   */
  workdayEndHour?: null | number;
  outsideAirflow?: VolumetricFlowRateValue;
  returnAirflow?: VolumetricFlowRateValue;
  winterReturnAirTemperature?: TemperatureValue;
  winterSupplyAirTemperature?: TemperatureValue;
  /**
   * @format double
   * @min 0
   * @max 1.7976931348623157e+308
   */
  heatingEfficiency?: null | number;
  summerReturnAirTemperature?: TemperatureValue;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  returnAirRelativeHumidity?: null | number;
  summerSupplyAirTemperature?: TemperatureValue;
  roomDesignTemperature?: TemperatureValue;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  roomDesignRelativeHumidity?: null | number;
  economizerEnabled?: null | boolean;
  enthalpyEconomizerEnabled?: null | boolean;
  economizerEnthalpyDifferenceCriterion?: OtherValue;
  economizerTemperatureDifferenceCriterion?: TemperatureValue;
  /**
   * @format double
   * @min 0
   * @max 1.7976931348623157e+308
   */
  coolingEfficiency?: null | number;
  supplyFanAirflow?: VolumetricFlowRateValue;
  exhaustFanPressureDrop?: PressureValue;
  supplyFanPressureDrop?: PressureValue;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  fanEfficiency?: null | number;
  gasHeating?: null | boolean;
  heatingEnergyCost?: OtherValue;
  electricityCost: OtherValue;
  haltonPrice: OtherValue;
  competitorPrice: OtherValue;
  marvelPrice: OtherValue;
  fanAndDuctworkCostPerAirflow?: OtherValue;
  coolingEquipmentCost?: OtherValue;
  heatingEquipmentCost?: OtherValue;
  designCoolingReturnAirTemperature?: TemperatureValue;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  designCoolingReturnAirRelativeHumidity?: null | number;
  designCoolingSupplyAirTemperature?: TemperatureValue;
  designCoolingRoomTemperature?: TemperatureValue;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  designCoolingRoomRelativeHumidity?: null | number;
  designHeatingReturnAirTemperature?: TemperatureValue;
  designHeatingSupplyAirTemperature?: TemperatureValue;
  fanEnergyCost?: OtherValue;
  coolingEnergyCost?: OtherValue;
  /**
   * @format double
   * @min 0
   * @max 100
   */
  marvelPercentTimeIdlePerSystem?: null | number;
  coolingPlantCost?: OtherValue;
  heatingPlantCost?: OtherValue;
  [key: string]: any;
}

export interface PaybackOutputs {
  /** @format int32 */
  totalWorkingHours?: null | number;
  /** @format int32 */
  totalHeatHours?: null | number;
  /** @format int32 */
  totalCoolHours?: null | number;
  coolingCapacity?: PowerValue;
  heatingCapacity?: PowerValue;
  haltonHeatingEnergyAnnual?: EnergyValue;
  haltonCoolingEnergyAnnual?: EnergyValue;
  haltonFanEnergyAnnual?: EnergyValue;
  competitorHeatingEnergyAnnual?: EnergyValue;
  competitorCoolingEnergyAnnual?: EnergyValue;
  competitorFanEnergyAnnual?: EnergyValue;
  marvelHeatingEnergyAnnual?: EnergyValue;
  marvelCoolingEnergyAnnual?: EnergyValue;
  marvelFanEnergyAnnual?: EnergyValue;
  haltonCO2Annual?: MassValue;
  competitorCO2Annual?: MassValue;
  marvelCO2Annual?: MassValue;
  haltonEnergyTotal: EnergyValue;
  competitorEnergyTotal: EnergyValue;
  marvelEnergyTotal: EnergyValue;
  /** @format double */
  energySavingsVsCompetitor?: null | number;
  /** @format double */
  energySavingsMarvel?: null | number;
  annualSavingsVsCompetitor?: OtherValue;
  annualSavingsMarvel?: OtherValue;
  /**
   * @format double
   * @min 0
   * @max 1.7976931348623157e+308
   */
  paybackPeriodVsCompetitor: number;
  /**
   * @format double
   * @min 0
   * @max 1.7976931348623157e+308
   */
  paybackPeriodMarvel: number;
  costHeatingEnergy?: OtherValue;
  costCoolingEquipment?: OtherValue;
  costFandDuct?: OtherValue;
  configMarvelExhaustAirflow?: VolumetricFlowRateValue;
  configHaltonExhaustAirflow?: VolumetricFlowRateValue;
  configCompetitorExhaustAirflow?: VolumetricFlowRateValue;
  configMarvelExhaustPressureDrop?: PressureValue;
  configHaltonExhaustPressureDrop?: PressureValue;
  configCompetitorExhaustPressureDrop?: PressureValue;
  configMarvelSupplyAirflow?: VolumetricFlowRateValue;
  configHaltonSupplyAirflow?: VolumetricFlowRateValue;
  configCompetitorSupplyAirflow?: VolumetricFlowRateValue;
  configMarvelSupplyPressureDrop?: PressureValue;
  configHaltonSupplyPressureDrop?: PressureValue;
  configCompetitorSupplyPressureDrop?: PressureValue;
  configMarvelExpenditures?: OtherValue;
  configHaltonExpenditures?: OtherValue;
  configCompetitorExpenditures?: OtherValue;
  configMarvelExpendituresDiff?: OtherValue;
  configHaltonExpendituresDiff?: OtherValue;
  savingsAnnualMarvelCooling?: OtherValue;
  savingsAnnualHaltonCooling?: OtherValue;
  savingsAnnualMarvelHeating?: OtherValue;
  savingsAnnualHaltonHeating?: OtherValue;
  savingsAnnualMarvelFan?: OtherValue;
  savingsAnnualHaltonFan?: OtherValue;
  savingsExpenditureMarvelCooling?: OtherValue;
  savingsExpenditureHaltonCooling?: OtherValue;
  savingsExpenditureMarvelHeating?: OtherValue;
  savingsExpenditureHaltonHeating?: OtherValue;
  savingsExpenditureMarvelFan?: OtherValue;
  savingsExpenditureHaltonFan?: OtherValue;
  savingsExpenditureMarvelTotal?: OtherValue;
  savingsExpenditureHaltonTotal?: OtherValue;
  /**
   * @format double
   * @min 0
   * @max 1.7976931348623157e+308
   */
  paybackPeriodExpendituresMarvel?: null | number;
  /**
   * @format double
   * @min 0
   * @max 1.7976931348623157e+308
   */
  paybackPeriodExpendituresHalton?: null | number;
}

export interface Position {
  x: LengthValue;
  y: LengthValue;
  z: LengthValue;
}

export interface PositionPartial {
  x?: LengthValue;
  y?: LengthValue;
  z?: LengthValue;
}

export interface PositionPlane {
  x: LengthValue;
  y: LengthValue;
}

export interface PowerValue {
  /** @format double */
  value: number;
  type: "power";
  unit: string;
  unitSystem?: null | string;
}

export interface PressureValue {
  /** @format double */
  value: number;
  type: "pressure";
  unit: string;
  unitSystem?: null | string;
}

export interface ProblemDetails {
  type?: null | string;
  title?: null | string;
  /** @format int32 */
  status?: null | number;
  detail?: null | string;
  instance?: null | string;
}

export interface Project {
  schemaPath: string;
  id: ProjectId;
  type: "project";
  rooms: Record<RoomId, Room>;
  groups: Record<GroupId, Group>;
  appliances: Record<ApplianceId, Appliance>;
  hoods: Record<HoodId, Hood>;
  zones: Record<ZoneId, Zone>;
  supplies: Record<SupplyId, Supply>;
  exhausts: Record<ExhaustId, Exhaust>;
  vavs: Record<VAVId, VAV>;
  diffusers: Record<DiffuserId, Diffuser>;
  ceilings: Record<VentilatedCeilingId, VentilatedCeiling>;
  airchefValues: ProjectAirchefValues;
  haltonValues: HaltonValues;
  comments?: null | Comment[];
  equations: Equations[];
  warnings?: null | Record<string, DataWarning[]>;
}

export interface ProjectAirchefValues {
  name: string;
  quoteNumber: string;
  country: string;
  state?: null | string;
  city: string;
  engineer: string;
  drawnBy?: null | string;
  drawingNumber?: null | string;
  notes?: null | string;
  datesAndAudit: DatesAndAudit;
  weatherCity: Enum;
  [key: string]: any;
}

export interface ProjectTemplatesResponse {
  projectTemplatesByType?: Record<string, Project>;
  types?: string[];
}

export interface Room {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: RoomId;
  /** @minLength 1 */
  type: "room";
  schemaPath: string;
  airchefValues: RoomAirchefValues;
  haltonValues: HaltonValues;
  relations: RoomRelations;
}

export interface RoomAirchefValues {
  name: string;
  datesAndAudit: DatesAndAudit;
  autogenerated?: null | boolean;
  diffuserInfo?: RoomDiffuserInfo;
  [key: string]: any;
}

export interface RoomDiffuserInfo {
  existingDiffusers?: null | Record<string, any>;
  requiredDiffusers?: null | Record<string, any>;
  requiredAirflow?: VolumetricFlowRateValue;
  existingAirflow?: VolumetricFlowRateValue;
  [key: string]: any;
}

export interface RoomRelations {
  corners: Record<string, Corner>;
  walls: Record<string, Wall>;
  sectors: Record<string, Sector>;
  zoneIds: ZoneId[];
}

export interface Rotation {
  /** @format double */
  x: number;
  /** @format double */
  y: number;
  /** @format double */
  z: number;
}

export interface Row {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: RowId;
  /** @minLength 1 */
  type: "row";
  relations: RowRelations;
  airchefValues: RowAirchefValues;
  haltonValues?: HaltonValues;
}

export interface RowAirchefValues {
  hoodsPositionOffset?: PositionPartial;
  appliancesPositionOffset: PositionPlane;
  [key: string]: any;
}

export interface RowRelations {
  applianceIds: ApplianceId[];
  hoodIds: HoodId[];
  floatingApplianceIds: AppliancePositioner[];
}

export interface RunEquationFieldRequest {
  id: string;
  project: Project;
  item: any;
}

export interface Sector {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: string;
  walls: string[];
  [key: string]: any;
}

export interface SeedingErrorsSummary {
  objectId?: string;
  errors?: ValidatorResponseError[];
}

export interface Size {
  width: LengthValue;
  length: LengthValue;
  height: LengthValue;
}

export interface Supply {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: SupplyId;
  schemaPath: string;
  /** @minLength 1 */
  type: "supply";
  airchefValues: SupplyAirchefValues;
  haltonValues: HaltonValues;
  relations: SupplyRelations;
}

export interface SupplyAirchefValues {
  name: string;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  modelId?: null | string;
  description?: null | string;
  datesAndAudit: DatesAndAudit;
  comment?: null | string;
  image?: null | string;
  imageThumbnail?: null | string;
  [key: string]: any;
}

export interface SupplyPlenum {
  offsetTransform: OffsetTransformProperties;
  /**
   * @format int32
   * @min 1
   * @max 2
   */
  count: number;
  collarType: SupplyPlenumCollarType;
  collarLength: LengthValue;
  collarWidth: LengthValue;
  backDistance: LengthValue;
  centerDistance: LengthValue;
  [key: string]: any;
}

export interface SupplyRelations {
  zoneIds: ZoneId[];
  vavIds: VAVId[];
  diffuserIds: DiffuserId[];
  hoodIds?: null | HoodId[];
}

export interface TemperatureValue {
  /** @format double */
  value: number;
  type: "temperature";
  unit: string;
  unitSystem?: null | string;
}

export interface TickJobResponse {
  /** @minLength 1 */
  message: string;
  type: TickJobResponseType;
  outputs: null | TickJobResponseOutput[][];
  /** @format date-time */
  runAt: string;
}

export interface TickJobResponseOutput {
  /** @minLength 1 */
  jsonPath: string;
  /** @minLength 1 */
  operation: string;
  value?: null;
}

export interface Transform {
  position: Position;
  size: Size;
  rotation: Rotation;
}

export type UIElementTwoColumnHeader = (UtilRequiredKeys<
  BaseUiBasePart,
  "type"
> & {
  left?: LocalisedText;
  right?: LocalisedText;
}) & {
  type: "twoColHeader";
};

export type UIElementTwoColumnMeasurement = (UtilRequiredKeys<
  BaseUiBasePart,
  "type"
> & {
  left?: UIFieldMeasurementTyped;
  right?: UIFieldMeasurementTyped;
}) & {
  type: "twoColMeasurement";
};

export type UIFIeldRelationship = (UtilRequiredKeys<BaseUiBasePart, "type"> & {
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  readonly?: boolean;
  conditional?: ((
    | UtilRequiredKeys<UiFieldConditionalInt, "type">
    | UtilRequiredKeys<UiFieldConditionalBoolean, "type">
    | UtilRequiredKeys<UiFieldConditionalString, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurement, "type">
    | UtilRequiredKeys<UiFieldConditionalEnum, "type">
    | UtilRequiredKeys<UiFieldConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntRange, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
  required?: boolean;
  equation?: null | string;
  derived?: boolean;
  targetEntity: RelationshipEntity;
  /** @minLength 1 */
  titlePath: string;
  descriptionFields: UIFIeldRelationshipInfo[];
  multiple?: boolean;
  reverseLink?: string;
  reverseMultiple?: boolean;
}) & {
  type: "relationship";
};

export interface UIFIeldRelationshipInfo {
  label: Record<string, string>;
  /** @minLength 1 */
  path: string;
}

export type UIFieldBookmark = BaseUiBasePart & {
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  readonly?: boolean;
  conditional?: ((
    | UtilRequiredKeys<UiFieldConditionalInt, "type">
    | UtilRequiredKeys<UiFieldConditionalBoolean, "type">
    | UtilRequiredKeys<UiFieldConditionalString, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurement, "type">
    | UtilRequiredKeys<UiFieldConditionalEnum, "type">
    | UtilRequiredKeys<UiFieldConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntRange, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
  required?: boolean;
  equation?: null | string;
  derived?: boolean;
};

export type UIFieldChart = (UtilRequiredKeys<BaseUiBasePart, "type"> & {
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  readonly?: boolean;
  conditional?: ((
    | UtilRequiredKeys<UiFieldConditionalInt, "type">
    | UtilRequiredKeys<UiFieldConditionalBoolean, "type">
    | UtilRequiredKeys<UiFieldConditionalString, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurement, "type">
    | UtilRequiredKeys<UiFieldConditionalEnum, "type">
    | UtilRequiredKeys<UiFieldConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntRange, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
  required?: boolean;
  equation?: null | string;
  derived?: boolean;
  uPlotOptions?: any;
}) & {
  type: "chart";
};

export type UIFieldDate = (UtilRequiredKeys<BaseUiBasePart, "type"> & {
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  readonly?: boolean;
  conditional?: ((
    | UtilRequiredKeys<UiFieldConditionalInt, "type">
    | UtilRequiredKeys<UiFieldConditionalBoolean, "type">
    | UtilRequiredKeys<UiFieldConditionalString, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurement, "type">
    | UtilRequiredKeys<UiFieldConditionalEnum, "type">
    | UtilRequiredKeys<UiFieldConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntRange, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
  required?: boolean;
  equation?: null | string;
  derived?: boolean;
}) & {
  type: "date";
};

export type UIFieldMeasurement = (UtilRequiredKeys<BaseUiBasePart, "type"> & {
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  readonly?: boolean;
  conditional?: ((
    | UtilRequiredKeys<UiFieldConditionalInt, "type">
    | UtilRequiredKeys<UiFieldConditionalBoolean, "type">
    | UtilRequiredKeys<UiFieldConditionalString, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurement, "type">
    | UtilRequiredKeys<UiFieldConditionalEnum, "type">
    | UtilRequiredKeys<UiFieldConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntRange, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
  required?: boolean;
  equation?: null | string;
  derived?: boolean;
  control?: UIFieldNumericControl;
  measurementType: MeasurementType;
  preferredUnits?: UIFieldMeasurementPreferredUnits;
  validation?: UIFieldMeasurementValidation;
  fractionDigits?: UIFieldMeasurementFractionDigits;
}) & {
  type: "measurement";
};

export interface UIFieldMeasurementFractionDigits {
  /** @format int32 */
  us?: null | number;
  /** @format int32 */
  si?: null | number;
}

export interface UIFieldMeasurementPreferredUnits {
  us?: null | string;
  si?: null | string;
}

export interface UIFieldMeasurementTyped {
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  readonly?: boolean;
  conditional?: ((
    | UtilRequiredKeys<UiFieldConditionalInt, "type">
    | UtilRequiredKeys<UiFieldConditionalBoolean, "type">
    | UtilRequiredKeys<UiFieldConditionalString, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurement, "type">
    | UtilRequiredKeys<UiFieldConditionalEnum, "type">
    | UtilRequiredKeys<UiFieldConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntRange, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
  required?: boolean;
  equation?: null | string;
  derived?: boolean;
  control?: UIFieldNumericControl;
  measurementType: MeasurementType;
  preferredUnits?: UIFieldMeasurementPreferredUnits;
  validation?: UIFieldMeasurementValidation;
  fractionDigits?: UIFieldMeasurementFractionDigits;
  type: "measurement";
}

export interface UIFieldMeasurementValidation {
  /** @format float */
  minValue?: null | number;
  /** @format float */
  maxValue?: null | number;
  minValueJsonPath?: null | string;
  maxValueJsonPath?: null | string;
  stepValueJsonPath?: null | string;
}

export type UIFieldModule = (UtilRequiredKeys<BaseUiBasePart, "type"> & {
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  readonly?: boolean;
  conditional?: ((
    | UtilRequiredKeys<UiFieldConditionalInt, "type">
    | UtilRequiredKeys<UiFieldConditionalBoolean, "type">
    | UtilRequiredKeys<UiFieldConditionalString, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurement, "type">
    | UtilRequiredKeys<UiFieldConditionalEnum, "type">
    | UtilRequiredKeys<UiFieldConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntRange, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
  required?: boolean;
  equation?: null | string;
  derived?: boolean;
  /** @minLength 1 */
  moduleType: string;
  validation?: UiFieldModuleValidation;
}) & {
  type: "module";
};

export type UIFieldNumber = (UtilRequiredKeys<BaseUiBasePart, "type"> & {
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  readonly?: boolean;
  conditional?: ((
    | UtilRequiredKeys<UiFieldConditionalInt, "type">
    | UtilRequiredKeys<UiFieldConditionalBoolean, "type">
    | UtilRequiredKeys<UiFieldConditionalString, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurement, "type">
    | UtilRequiredKeys<UiFieldConditionalEnum, "type">
    | UtilRequiredKeys<UiFieldConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntRange, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
  required?: boolean;
  equation?: null | string;
  derived?: boolean;
  control?: UIFieldNumericControl;
  /** @format float */
  step?: null | number;
  validation?: UIFieldNumberValidation;
}) & {
  type: "number";
};

export interface UIFieldNumberValidation {
  /** @format int32 */
  minValue?: null | number;
  /** @format int32 */
  maxValue?: null | number;
  minValueJsonPath?: null | string;
  maxValueJsonPath?: null | string;
  stepValueJsonPath?: null | string;
}

export type UIFieldRadioButtons = (UtilRequiredKeys<BaseUiBasePart, "type"> & {
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  readonly?: boolean;
  conditional?: ((
    | UtilRequiredKeys<UiFieldConditionalInt, "type">
    | UtilRequiredKeys<UiFieldConditionalBoolean, "type">
    | UtilRequiredKeys<UiFieldConditionalString, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurement, "type">
    | UtilRequiredKeys<UiFieldConditionalEnum, "type">
    | UtilRequiredKeys<UiFieldConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntRange, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
  required?: boolean;
  equation?: null | string;
  derived?: boolean;
  validation?: UIFieldRadioButtonsValidation;
  options: UIOption[];
}) & {
  type: "radioButtons";
};

export type UIFieldRadioButtonsEnum = BaseUiBasePart & {
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  readonly?: boolean;
  conditional?: ((
    | UtilRequiredKeys<UiFieldConditionalInt, "type">
    | UtilRequiredKeys<UiFieldConditionalBoolean, "type">
    | UtilRequiredKeys<UiFieldConditionalString, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurement, "type">
    | UtilRequiredKeys<UiFieldConditionalEnum, "type">
    | UtilRequiredKeys<UiFieldConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntRange, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
  required?: boolean;
  equation?: null | string;
  derived?: boolean;
};

export interface UIFieldRadioButtonsValidation {
  required?: boolean;
}

export type UIFieldSelect = (UtilRequiredKeys<BaseUiBasePart, "type"> & {
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  readonly?: boolean;
  conditional?: ((
    | UtilRequiredKeys<UiFieldConditionalInt, "type">
    | UtilRequiredKeys<UiFieldConditionalBoolean, "type">
    | UtilRequiredKeys<UiFieldConditionalString, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurement, "type">
    | UtilRequiredKeys<UiFieldConditionalEnum, "type">
    | UtilRequiredKeys<UiFieldConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntRange, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
  required?: boolean;
  equation?: null | string;
  derived?: boolean;
  default?: null | string;
  options: UIOption[];
}) & {
  type: "select";
};

export type UIFieldSelectEnum = (UtilRequiredKeys<BaseUiBasePart, "type"> & {
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  readonly?: boolean;
  conditional?: ((
    | UtilRequiredKeys<UiFieldConditionalInt, "type">
    | UtilRequiredKeys<UiFieldConditionalBoolean, "type">
    | UtilRequiredKeys<UiFieldConditionalString, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurement, "type">
    | UtilRequiredKeys<UiFieldConditionalEnum, "type">
    | UtilRequiredKeys<UiFieldConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntRange, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
  required?: boolean;
  equation?: null | string;
  derived?: boolean;
}) & {
  type: "selectEnum";
};

export type UIFieldSelectNumber = (UtilRequiredKeys<BaseUiBasePart, "type"> & {
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  readonly?: boolean;
  conditional?: ((
    | UtilRequiredKeys<UiFieldConditionalInt, "type">
    | UtilRequiredKeys<UiFieldConditionalBoolean, "type">
    | UtilRequiredKeys<UiFieldConditionalString, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurement, "type">
    | UtilRequiredKeys<UiFieldConditionalEnum, "type">
    | UtilRequiredKeys<UiFieldConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntRange, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
  required?: boolean;
  equation?: null | string;
  derived?: boolean;
  default?: null | string;
  options: UIOptionNumber[];
}) & {
  type: "selectNumber";
};

export type UIFieldText = (UtilRequiredKeys<BaseUiBasePart, "type"> & {
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  readonly?: boolean;
  conditional?: ((
    | UtilRequiredKeys<UiFieldConditionalInt, "type">
    | UtilRequiredKeys<UiFieldConditionalBoolean, "type">
    | UtilRequiredKeys<UiFieldConditionalString, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurement, "type">
    | UtilRequiredKeys<UiFieldConditionalEnum, "type">
    | UtilRequiredKeys<UiFieldConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntRange, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
  required?: boolean;
  equation?: null | string;
  derived?: boolean;
  validation?: UiFieldTextValidation;
}) & {
  type: "text";
};

export type UIFieldTextArea = (UtilRequiredKeys<BaseUiBasePart, "type"> & {
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  readonly?: boolean;
  conditional?: ((
    | UtilRequiredKeys<UiFieldConditionalInt, "type">
    | UtilRequiredKeys<UiFieldConditionalBoolean, "type">
    | UtilRequiredKeys<UiFieldConditionalString, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurement, "type">
    | UtilRequiredKeys<UiFieldConditionalEnum, "type">
    | UtilRequiredKeys<UiFieldConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntRange, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
  required?: boolean;
  equation?: null | string;
  derived?: boolean;
}) & {
  type: "textarea";
};

export type UIFieldTime = (UtilRequiredKeys<BaseUiBasePart, "type"> & {
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  readonly?: boolean;
  conditional?: ((
    | UtilRequiredKeys<UiFieldConditionalInt, "type">
    | UtilRequiredKeys<UiFieldConditionalBoolean, "type">
    | UtilRequiredKeys<UiFieldConditionalString, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurement, "type">
    | UtilRequiredKeys<UiFieldConditionalEnum, "type">
    | UtilRequiredKeys<UiFieldConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntRange, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
  required?: boolean;
  equation?: null | string;
  derived?: boolean;
}) & {
  type: "time";
};

export type UIFieldToggle = (UtilRequiredKeys<BaseUiBasePart, "type"> & {
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  readonly?: boolean;
  conditional?: ((
    | UtilRequiredKeys<UiFieldConditionalInt, "type">
    | UtilRequiredKeys<UiFieldConditionalBoolean, "type">
    | UtilRequiredKeys<UiFieldConditionalString, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurement, "type">
    | UtilRequiredKeys<UiFieldConditionalEnum, "type">
    | UtilRequiredKeys<UiFieldConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiFieldConditionalIntRange, "type">
    | UtilRequiredKeys<UiFieldConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
  required?: boolean;
  equation?: null | string;
  derived?: boolean;
}) & {
  type: "toggle";
};

export interface UIGroup {
  label: LocalisedText;
  fields: (
    | UIFieldText
    | UIFieldDate
    | UIFieldTime
    | UIFieldToggle
    | UIFieldNumber
    | UIFieldRadioButtons
    | UIFieldRadioButtonsEnum
    | UIFieldSelect
    | UIFieldSelectNumber
    | UIFieldSelectEnum
    | UIFieldMeasurement
    | UIFieldTextArea
    | UIFIeldRelationship
    | UIFieldModule
    | UIFieldChart
    | UIFieldBookmark
    | UIElementTwoColumnHeader
    | UIElementTwoColumnMeasurement
  )[];
  conditional?: ((
    | UtilRequiredKeys<UiGroupConditionalInt, "type">
    | UtilRequiredKeys<UiGroupConditionalBoolean, "type">
    | UtilRequiredKeys<UiGroupConditionalString, "type">
    | UtilRequiredKeys<UiGroupConditionalMeasurement, "type">
    | UtilRequiredKeys<UiGroupConditionalEnum, "type">
    | UtilRequiredKeys<UiGroupConditionalStringIncludes, "type">
    | UtilRequiredKeys<UiGroupConditionalIntegerIncludes, "type">
    | UtilRequiredKeys<UiGroupConditionalMeasurementIncludes, "type">
    | UtilRequiredKeys<UiGroupConditionalModuleIncludes, "type">
    | UtilRequiredKeys<UiGroupConditionalIntRange, "type">
    | UtilRequiredKeys<UiGroupConditionalMeasurementRange, "type">
  ) & {
    type: string;
  })[];
}

export interface UIOption {
  /** @minLength 1 */
  value: string;
  label: LocalisedText;
}

export interface UIOptionNumber {
  /** @format int32 */
  value: number;
  label: LocalisedText;
}

export type UiFieldConditionalBoolean = (UtilRequiredKeys<
  BaseUiFieldConditional,
  "type"
> & {
  operator: UiFieldConditionalBoolOperator;
  expectedValue?: boolean;
}) & {
  type: "boolean";
};

export type UiFieldConditionalEnum = (UtilRequiredKeys<
  BaseUiFieldConditional,
  "type"
> & {
  operator: UiFieldConditionalBoolOperator;
  expectedValue?: string;
}) & {
  type: "enum";
};

export type UiFieldConditionalInt = (UtilRequiredKeys<
  BaseUiFieldConditional,
  "type"
> & {
  operator: UiFieldConditionalBoolOperator;
  /** @format int32 */
  expectedValue?: number;
}) & {
  type: "int";
};

export type UiFieldConditionalIntRange = (UtilRequiredKeys<
  BaseUiFieldConditional,
  "type"
> & {
  /** @format int32 */
  minIntValue?: null | number;
  /** @format int32 */
  maxIntValue?: null | number;
  operator: UiFieldConditionalRangeOperator;
}) & {
  type: "intRange";
};

export type UiFieldConditionalIntegerIncludes = (UtilRequiredKeys<
  BaseUiFieldConditional,
  "type"
> & {
  operator: UiFieldIncludesOperator;
  expectedValue?: number[];
}) & {
  type: "intIncludes";
};

export type UiFieldConditionalMeasurement = (UtilRequiredKeys<
  BaseUiFieldConditional,
  "type"
> & {
  operator: UiFieldConditionalBoolOperator;
  /** @format int32 */
  expectedValue?: number;
  unit?: null | string;
}) & {
  type: "measurement";
};

export type UiFieldConditionalMeasurementIncludes = (UtilRequiredKeys<
  BaseUiFieldConditional,
  "type"
> & {
  operator: UiFieldIncludesOperator;
  expectedValue?: number[];
  unit?: null | string;
}) & {
  type: "measurementIncludes";
};

export type UiFieldConditionalMeasurementRange = (UtilRequiredKeys<
  BaseUiFieldConditional,
  "type"
> & {
  /** @format int32 */
  minIntValue?: null | number;
  /** @format int32 */
  maxIntValue?: null | number;
  operator: UiFieldConditionalRangeOperator;
  unit?: null | string;
}) & {
  type: "measurementRange";
};

export type UiFieldConditionalModuleIncludes = (UtilRequiredKeys<
  BaseUiFieldConditional,
  "type"
> & {
  operator: UiFieldIncludesOperator;
  expectedValue?: string[];
}) & {
  type: "moduleIncludes";
};

export type UiFieldConditionalString = (UtilRequiredKeys<
  BaseUiFieldConditional,
  "type"
> & {
  operator: UiFieldConditionalBoolOperator;
  expectedValue?: string;
}) & {
  type: "string";
};

export type UiFieldConditionalStringIncludes = (UtilRequiredKeys<
  BaseUiFieldConditional,
  "type"
> & {
  operator: UiFieldIncludesOperator;
  expectedValue?: string[];
}) & {
  type: "stringIncludes";
};

export interface UiFieldModuleValidation {
  /** @format int32 */
  minCount?: null | number;
  /** @format int32 */
  maxCount?: null | number;
}

export interface UiFieldTextValidation {
  /** @format int32 */
  minLength?: null | number;
  /** @format int32 */
  maxLength?: null | number;
}

export type UiGroupConditionalBoolean = (UtilRequiredKeys<
  BaseUiGroupConditional,
  "type"
> & {
  operator: UiFieldConditionalBoolOperator;
  expectedValue?: boolean;
}) & {
  type: "boolean";
};

export type UiGroupConditionalEnum = (UtilRequiredKeys<
  BaseUiGroupConditional,
  "type"
> & {
  operator: UiFieldConditionalBoolOperator;
  expectedValue?: string;
}) & {
  type: "enum";
};

export type UiGroupConditionalInt = (UtilRequiredKeys<
  BaseUiGroupConditional,
  "type"
> & {
  operator: UiFieldConditionalBoolOperator;
  /** @format int32 */
  expectedValue?: number;
}) & {
  type: "int";
};

export type UiGroupConditionalIntRange = (UtilRequiredKeys<
  BaseUiGroupConditional,
  "type"
> & {
  /** @format int32 */
  minIntValue?: null | number;
  /** @format int32 */
  maxIntValue?: null | number;
  operator: UiFieldConditionalRangeOperator;
}) & {
  type: "intRange";
};

export type UiGroupConditionalIntegerIncludes = (UtilRequiredKeys<
  BaseUiGroupConditional,
  "type"
> & {
  operator: UiFieldIncludesOperator;
  expectedValue?: number[];
}) & {
  type: "intIncludes";
};

export type UiGroupConditionalMeasurement = (UtilRequiredKeys<
  BaseUiGroupConditional,
  "type"
> & {
  operator: UiFieldConditionalBoolOperator;
  /** @format int32 */
  expectedValue?: number;
  unit?: null | string;
}) & {
  type: "measurement";
};

export type UiGroupConditionalMeasurementIncludes = (UtilRequiredKeys<
  BaseUiGroupConditional,
  "type"
> & {
  operator: UiFieldIncludesOperator;
  expectedValue?: number[];
  unit?: null | string;
}) & {
  type: "measurementIncludes";
};

export type UiGroupConditionalMeasurementRange = (UtilRequiredKeys<
  BaseUiGroupConditional,
  "type"
> & {
  /** @format int32 */
  minIntValue?: null | number;
  /** @format int32 */
  maxIntValue?: null | number;
  operator: UiFieldConditionalRangeOperator;
  unit?: null | string;
}) & {
  type: "measurementRange";
};

export type UiGroupConditionalModuleIncludes = (UtilRequiredKeys<
  BaseUiGroupConditional,
  "type"
> & {
  operator: UiFieldIncludesOperator;
  expectedValue?: string[];
}) & {
  type: "moduleIncludes";
};

export type UiGroupConditionalString = (UtilRequiredKeys<
  BaseUiGroupConditional,
  "type"
> & {
  operator: UiFieldConditionalBoolOperator;
  expectedValue?: string;
}) & {
  type: "string";
};

export type UiGroupConditionalStringIncludes = (UtilRequiredKeys<
  BaseUiGroupConditional,
  "type"
> & {
  operator: UiFieldIncludesOperator;
  expectedValue?: string[];
}) & {
  type: "stringIncludes";
};

export interface VAV {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: VAVId;
  /** @minLength 1 */
  type: "vav";
  schemaPath: string;
  airchefValues: VAVAirchefValues;
  haltonValues: HaltonValues;
  relations: VAVRelations;
}

export interface VAVAirchefValues {
  name: string;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  modelId?: null | string;
  description?: null | string;
  transform: Transform;
  datesAndAudit: DatesAndAudit;
  comment?: null | string;
  image?: null | string;
  [key: string]: any;
}

export interface VAVRelations {
  roomId?: RoomId;
  supplyId?: null | SupplyId;
  diffuserIds?: null | DiffuserId[];
  zoneId?: null | ZoneId;
  hoodIds?: null | HoodId[];
}

export interface ValidatorResponseError {
  path?: string;
  message?: string;
  error_property?: string;
  error_schema_id?: string;
  error_schema_title?: string;
  context?: ValidatorResponseError[];
}

export interface VentilatedCeiling {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: VentilatedCeilingId;
  schemaPath: string;
  /** @minLength 1 */
  type: "ceiling";
  airchefValues: CeilingAirchefValues;
  haltonValues: HaltonValues;
  relations: CeilingRelations;
}

export interface VolumetricFlowRateValue {
  /** @format double */
  value: number;
  type: "volumetricFlowRate";
  unit: string;
  unitSystem?: null | string;
}

export interface Wall {
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: string;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  start: string;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  end: string;
  sectors: string[];
  [key: string]: any;
}

export interface Zone {
  schemaPath: string;
  /** @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$ */
  id: ZoneId;
  /** @minLength 1 */
  type: "zone";
  relations: ZoneRelations;
  airchefValues: ZoneAirchefValues;
  haltonValues: HaltonValues;
}

export interface ZoneAirchefValues {
  name: string;
  datesAndAudit: DatesAndAudit;
  comment?: null | string;
  [key: string]: any;
}

export interface ZoneRelations {
  supplyIds: SupplyId[];
  exhaustIds: ExhaustId[];
  roomIds: RoomId[];
}

interface BaseUiFieldConditional {
  type: string;
  /** @minLength 1 */
  jsonPath: string;
  result: UiFieldConditionalResult;
  disallowResult?: string[];
}

type BaseUiFieldConditionalTypeMapping<Key, Type> = {
  type: Key;
} & Type;

interface BaseUiGroupConditional {
  type: string;
  /** @minLength 1 */
  jsonPath: string;
  result: UIGroupConditionalResult;
}

type BaseUiGroupConditionalTypeMapping<Key, Type> = {
  type: Key;
} & Type;

interface BaseUiBasePart {
  type: string;
}

type BaseUiBasePartTypeMapping<Key, Type> = {
  type: Key;
} & Type;

interface BaseDataViewColumn {
  type: string;
  /** @minLength 1 */
  path: string;
  label: LocalisedText;
  /** @minLength 1 */
  id: string;
}

type BaseDataViewColumnTypeMapping<Key, Type> = {
  type: Key;
} & Type;

export interface AppliancesListParams {
  query?: string;
  type?: string;
  schemaPath?: string;
}

export type AppliancesListData = AppliancesResponse;

export type AppliancesCreateData = Appliance;

export interface AppliancesDetailParams {
  id: string;
}

export type AppliancesDetailData = Appliance;

export interface AppliancesUpdateParams {
  id: string;
}

export type AppliancesUpdateData = Appliance;

export interface AppliancesDeleteParams {
  id: string;
}

export type AppliancesDeleteData = any;

export type ConversiontableListData = Record<string, Record<string, string>>;

export type SymbolsByUnitListData = Record<string, string[]>;

export interface DataviewListParams {
  schema?: string;
  haltonType?: string;
  itemType?: string;
}

export type DataviewListData = DataView[];

export interface DataviewCreateParams {
  schema?: string;
  haltonType?: string;
}

export type DataviewCreateData = any;

export interface DataviewDetailParams {
  /** @format uuid */
  id: string;
}

export type DataviewDetailData = DataView;

export interface DataviewUpdateParams {
  /** @format uuid */
  id: string;
}

export type DataviewUpdateData = any;

export interface DataviewDeleteParams {
  /** @format uuid */
  id: string;
}

export type DataviewDeleteData = any;

export interface EquationsListParams {
  schema?: string;
  haltonType?: string;
}

export type EquationsListData = EquationsDatabaseSchema[];

export type EquationsListError = ProblemDetails;

export type EquationsCreatePayload = Equation[];

export interface EquationsCreateParams {
  schemaPath?: string;
  haltonType?: string;
}

export type EquationsCreateData = Equation[];

export type EquationsCreateError = ProblemDetails;

export type EquationsUpdatePayload = Equation[];

export interface EquationsUpdateParams {
  schemaPath?: string;
  haltonType?: string;
}

export type EquationsUpdateData = any;

export type EquationsUpdateError = ProblemDetails;

export type VariablesListData = any;

export type PostEquationsData = any;

export type RunFieldEquationCreateData = any;

export type VersionsInBulkListData = Record<string, string[]>;

export interface GroupsListParams {
  schemaPath?: string;
}

export type GroupsListData = Group;

export type GroupsCreateData = Group;

export type GenerateCreateData = GeneratePdfResponse;

export type TemplatesListData = ProjectTemplatesResponse;

export interface TemplatesUpdateParams {
  id: string;
}

export type TemplatesUpdateData = Project;

export type ProjectsListData = Project[];

export type ProjectsCreateData = Project;

export interface ProjectsDetailParams {
  id: string;
}

export type ProjectsDetailData = Project;

export interface ProjectsUpdateParams {
  id: string;
}

export type ProjectsUpdateData = string;

export interface ProjectsDeleteParams {
  id: string;
}

export type ProjectsDeleteData = any;

export type ValidateCreateData = Project;

export interface ReseedCreateParams {
  type?: string;
  surely?: string;
}

export type ReseedCreateData = SeedingErrorsSummary[];

export interface RoomsListParams {
  schemaPath?: string;
}

export type RoomsListData = Room;

export type RoomsCreateData = Room;

export interface RoomsUpdateParams {
  id: string;
}

export type RoomsUpdateData = Room;

export interface GetUiParams {
  schema?: string;
  haltonType?: string;
}

export type GetUiData = UIGroup[];

export type PostUiPayload = UIGroup[];

export interface PostUiParams {
  schema?: string;
  haltonType?: string;
}

export type PostUiData = any;

export type PutUiPayload = UIGroup[];

export interface PutUiParams {
  schema?: string;
  haltonType?: string;
}

export type PutUiData = any;

export type DataCreatePayload = any;

export type DataCreateData = any;

export interface EquationCreateParams {
  schemaPath?: string;
}

export type EquationCreateData = any;

export interface ZonesListParams {
  schemaPath?: string;
}

export type ZonesListData = Zone;

export type ZonesCreateData = Zone;

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export type ContentType =
  | "application/json"
  | "application/vnd.api+json"
  | "multipart/form-data"
  | "application/x-www-form-urlencoded"
  | "text/plain";

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === "multipart/form-data" &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === "text/plain" &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AirChef.API
 * @version 1.0
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  appliance = {
    /**
     * No description
     *
     * @tags Appliance
     * @name AppliancesList
     * @request GET:/appliances
     * @secure
     */
    appliancesList: (
      query: AppliancesListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<AppliancesListData, any>({
        path: `/appliances`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Appliance
     * @name AppliancesCreate
     * @request POST:/appliances
     * @secure
     */
    appliancesCreate: (data: Appliance, params: RequestParams = {}) =>
      this.request<AppliancesCreateData, any>({
        path: `/appliances`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Appliance
     * @name AppliancesDetail
     * @request GET:/appliances/{id}
     * @secure
     */
    appliancesDetail: (
      { id }: AppliancesDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<AppliancesDetailData, any>({
        path: `/appliances/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Appliance
     * @name AppliancesUpdate
     * @request PUT:/appliances/{id}
     * @secure
     */
    appliancesUpdate: (
      { id }: AppliancesUpdateParams,
      data: Appliance,
      params: RequestParams = {},
    ) =>
      this.request<AppliancesUpdateData, any>({
        path: `/appliances/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Appliance
     * @name AppliancesDelete
     * @request DELETE:/appliances/{id}
     * @secure
     */
    appliancesDelete: (
      { id }: AppliancesDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<AppliancesDeleteData, any>({
        path: `/appliances/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  conversionTable = {
    /**
     * No description
     *
     * @tags ConversionTable
     * @name ConversiontableList
     * @request GET:/conversiontable
     * @secure
     */
    conversiontableList: (params: RequestParams = {}) =>
      this.request<ConversiontableListData, any>({
        path: `/conversiontable`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConversionTable
     * @name SymbolsByUnitList
     * @request GET:/conversiontable/symbolsByUnit
     * @secure
     */
    symbolsByUnitList: (params: RequestParams = {}) =>
      this.request<SymbolsByUnitListData, any>({
        path: `/conversiontable/symbolsByUnit`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  dataView = {
    /**
     * No description
     *
     * @tags DataView
     * @name DataviewList
     * @request GET:/dataview
     * @secure
     */
    dataviewList: (
      query: DataviewListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<DataviewListData, any>({
        path: `/dataview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataView
     * @name DataviewCreate
     * @request POST:/dataview
     * @secure
     */
    dataviewCreate: (
      query: DataviewCreateParams = {},
      data: DataViewItemConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<DataviewCreateData, any>({
        path: `/dataview`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataView
     * @name DataviewDetail
     * @request GET:/dataview/{id}
     * @secure
     */
    dataviewDetail: (
      { id }: DataviewDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<DataviewDetailData, any>({
        path: `/dataview/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataView
     * @name DataviewUpdate
     * @request PUT:/dataview/{id}
     * @secure
     */
    dataviewUpdate: (
      { id }: DataviewUpdateParams,
      data: DataViewItemConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<DataviewUpdateData, any>({
        path: `/dataview/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DataView
     * @name DataviewDelete
     * @request DELETE:/dataview/{id}
     * @secure
     */
    dataviewDelete: (
      { id }: DataviewDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DataviewDeleteData, any>({
        path: `/dataview/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  equations = {
    /**
     * No description
     *
     * @tags Equations
     * @name EquationsList
     * @request GET:/equations
     * @secure
     */
    equationsList: (
      query: EquationsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<EquationsListData, EquationsListError>({
        path: `/equations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equations
     * @name EquationsCreate
     * @request POST:/equations
     * @secure
     */
    equationsCreate: (
      query: EquationsCreateParams = {},
      data: EquationsCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<EquationsCreateData, EquationsCreateError>({
        path: `/equations`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equations
     * @name EquationsUpdate
     * @request PUT:/equations
     * @secure
     */
    equationsUpdate: (
      query: EquationsUpdateParams = {},
      data: EquationsUpdatePayload,
      params: RequestParams = {},
    ) =>
      this.request<EquationsUpdateData, EquationsUpdateError>({
        path: `/equations`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equations
     * @name VariablesList
     * @request GET:/equations/variables
     * @secure
     */
    variablesList: (params: RequestParams = {}) =>
      this.request<VariablesListData, any>({
        path: `/equations/variables`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equations
     * @name PostEquations
     * @request POST:/equations/run
     * @secure
     */
    postEquations: (data: EquationRunRequest, params: RequestParams = {}) =>
      this.request<PostEquationsData, any>({
        path: `/equations/run`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equations
     * @name RunFieldEquationCreate
     * @request POST:/equations/runFieldEquation
     * @secure
     */
    runFieldEquationCreate: (
      data: RunEquationFieldRequest,
      params: RequestParams = {},
    ) =>
      this.request<RunFieldEquationCreateData, any>({
        path: `/equations/runFieldEquation`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equations
     * @name VersionsInBulkList
     * @request GET:/equations/versionsInBulk
     * @secure
     */
    versionsInBulkList: (params: RequestParams = {}) =>
      this.request<VersionsInBulkListData, any>({
        path: `/equations/versionsInBulk`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  groups = {
    /**
     * No description
     *
     * @tags Groups
     * @name GroupsList
     * @request GET:/groups
     * @secure
     */
    groupsList: (query: GroupsListParams = {}, params: RequestParams = {}) =>
      this.request<GroupsListData, any>({
        path: `/groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name GroupsCreate
     * @request POST:/groups
     * @secure
     */
    groupsCreate: (data: Group, params: RequestParams = {}) =>
      this.request<GroupsCreateData, any>({
        path: `/groups`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  pdf = {
    /**
     * No description
     *
     * @tags Pdf
     * @name GenerateCreate
     * @request POST:/pdf/generate
     * @secure
     */
    generateCreate: (data: GeneratePdfRequest, params: RequestParams = {}) =>
      this.request<GenerateCreateData, any>({
        path: `/pdf/generate`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  project = {
    /**
     * No description
     *
     * @tags Project
     * @name TemplatesList
     * @request GET:/projects/templates
     * @secure
     */
    templatesList: (params: RequestParams = {}) =>
      this.request<TemplatesListData, any>({
        path: `/projects/templates`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name TemplatesUpdate
     * @request PUT:/projects/templates/{id}
     * @secure
     */
    templatesUpdate: (
      { id }: TemplatesUpdateParams,
      data: Project,
      params: RequestParams = {},
    ) =>
      this.request<TemplatesUpdateData, any>({
        path: `/projects/templates/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectsList
     * @request GET:/projects
     * @secure
     */
    projectsList: (params: RequestParams = {}) =>
      this.request<ProjectsListData, any>({
        path: `/projects`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectsCreate
     * @request POST:/projects
     * @secure
     */
    projectsCreate: (data: Project, params: RequestParams = {}) =>
      this.request<ProjectsCreateData, any>({
        path: `/projects`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectsDetail
     * @request GET:/projects/{id}
     * @secure
     */
    projectsDetail: (
      { id }: ProjectsDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<ProjectsDetailData, any>({
        path: `/projects/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectsUpdate
     * @request PUT:/projects/{id}
     * @secure
     */
    projectsUpdate: (
      { id }: ProjectsUpdateParams,
      data: Project,
      params: RequestParams = {},
    ) =>
      this.request<ProjectsUpdateData, any>({
        path: `/projects/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectsDelete
     * @request DELETE:/projects/{id}
     * @secure
     */
    projectsDelete: (
      { id }: ProjectsDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<ProjectsDeleteData, any>({
        path: `/projects/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ValidateCreate
     * @request POST:/projects/validate
     * @secure
     */
    validateCreate: (data: Project, params: RequestParams = {}) =>
      this.request<ValidateCreateData, any>({
        path: `/projects/validate`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  reseed = {
    /**
     * No description
     *
     * @tags Reseed
     * @name ReseedCreate
     * @request POST:/reseed
     * @secure
     */
    reseedCreate: (
      query: ReseedCreateParams = {},
      params: RequestParams = {},
    ) =>
      this.request<ReseedCreateData, any>({
        path: `/reseed`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  room = {
    /**
     * No description
     *
     * @tags Room
     * @name RoomsList
     * @request GET:/rooms
     * @secure
     */
    roomsList: (query: RoomsListParams = {}, params: RequestParams = {}) =>
      this.request<RoomsListData, any>({
        path: `/rooms`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Room
     * @name RoomsCreate
     * @request POST:/rooms
     * @secure
     */
    roomsCreate: (data: Room, params: RequestParams = {}) =>
      this.request<RoomsCreateData, any>({
        path: `/rooms`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Room
     * @name RoomsUpdate
     * @request PUT:/rooms/{id}
     * @secure
     */
    roomsUpdate: (
      { id }: RoomsUpdateParams,
      data: Room,
      params: RequestParams = {},
    ) =>
      this.request<RoomsUpdateData, any>({
        path: `/rooms/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  ui = {
    /**
     * No description
     *
     * @tags UI
     * @name GetUi
     * @request GET:/ui
     * @secure
     */
    getUi: (query: GetUiParams = {}, params: RequestParams = {}) =>
      this.request<GetUiData, any>({
        path: `/ui`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UI
     * @name PostUi
     * @request POST:/ui
     * @secure
     */
    postUi: (
      query: PostUiParams = {},
      data: PostUiPayload,
      params: RequestParams = {},
    ) =>
      this.request<PostUiData, any>({
        path: `/ui`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UI
     * @name PutUi
     * @request PUT:/ui
     * @secure
     */
    putUi: (
      query: PutUiParams = {},
      data: PutUiPayload,
      params: RequestParams = {},
    ) =>
      this.request<PutUiData, any>({
        path: `/ui`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),
  };
  validation = {
    /**
     * No description
     *
     * @tags Validation
     * @name DataCreate
     * @request POST:/validation/data
     * @secure
     */
    dataCreate: (data: DataCreatePayload, params: RequestParams = {}) =>
      this.request<DataCreateData, any>({
        path: `/validation/data`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Validation
     * @name EquationCreate
     * @request POST:/validation/equation
     * @secure
     */
    equationCreate: (
      query: EquationCreateParams = {},
      data: Equation,
      params: RequestParams = {},
    ) =>
      this.request<EquationCreateData, any>({
        path: `/validation/equation`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),
  };
  zones = {
    /**
     * No description
     *
     * @tags Zones
     * @name ZonesList
     * @request GET:/zones
     * @secure
     */
    zonesList: (query: ZonesListParams = {}, params: RequestParams = {}) =>
      this.request<ZonesListData, any>({
        path: `/zones`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zones
     * @name ZonesCreate
     * @request POST:/zones
     * @secure
     */
    zonesCreate: (data: Zone, params: RequestParams = {}) =>
      this.request<ZonesCreateData, any>({
        path: `/zones`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
}
